import { memo } from 'react'
import { ActivationStatus, useActivationState } from '../../connection/activate'
import { Stack, styled } from '@mui/material'
import { ActionButton } from '../Buttons/ActionButton'
import Iconfont from '../Iconfont'

const ErrorMessage = styled('div')`
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.color.text60};
  padding: 16px 0 40px;
`

export const Failed = memo(() => {
  const { activationState, cancelActivation } = useActivationState()

  if (activationState.status !== ActivationStatus.ERROR) return null

  return (
    <>
      <ErrorMessage>
        The connection attempt failed. Please click try again and follow the
        steps to connect in your wallet.
      </ErrorMessage>
      <Stack direction={'row'} spacing={1} justifyContent="flex-end">
        {/*<ActionButton*/}
        {/*  variant="outlined"*/}
        {/*  size="small"*/}
        {/*  onClick={cancelActivation}>*/}
        {/*  Back to wallet selection*/}
        {/*</ActionButton>*/}
        <ActionButton
          variant="contained"
          size="small"
          onClick={cancelActivation}>
          <Iconfont name="icon-refresh" size={16} />
          Try again
        </ActionButton>
      </Stack>
    </>
  )
})
